import Cookies from 'js-cookie';

const handler = ( $ ) => {

	/**
	 * Choose new photo image dialog
	 */
	$('.page-template-page-tpl-edit-profile #action-change-photo-btn').on( 'click', function( e ) {
		e.preventDefault();

		$( '#account-new-photo-input').trigger('click');
	});

	/**
	 * Uploading new photo
	 */
	$( '#account-new-photo-input').on( 'change', function( e ) {
		e.preventDefault();

		const $input = $( this ),
			inputVal = $input.val(),
			data = new FormData();

			data.append( 'action', 'account_change_photo');
			data.append( 'nonce', Cookies.get( 'wordpress_pen_ajax_nonce' ));

		if( $input[0].files.length > 0 ) {

			const ext = inputVal.substr( ( inputVal.lastIndexOf('.') +1) ).toLowerCase();
			const sizeInKb = Math.floor( $input[0].files[0].size / 1024 );

			if( ext != 'jpg' && ext != 'jpeg' && ext != 'png') {

				alert('This file type is not supported');
				return false;

			} else if ( sizeInKb > 2500 ) {

				alert('Please choose a file less than 2.5Mb');
				return false;

			}

			data.append( 'photo', $input[0].files[0] );

			$.ajax({
				url: themeVars.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: data,
				enctype: 'multipart/form-data',
				processData: false,
				contentType: false
			}).done( function( answer ) {

				$('.profile-avatar img').replaceWith( '<img src="' + answer.data.avatarURL + '" alt="">');
				$('#action-remove-photo-btn').show();

			});

		}

	});

	/**
	 * Delete the photo dialog
	 */
	$('.page-template-page-tpl-edit-profile #action-remove-photo-btn').on( 'click', function( e ) {
		e.preventDefault();

		$.ajax({
			url: themeVars.ajaxurl,
			type: 'POST',
			data: {
				action: 'account_set_default_photo',
				nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
			}
		}).done( () => {

			const placeholderURL = $(this).data('placeholder-url');
			$('.profile-avatar img').replaceWith( '<img class="default-avatar" src="' + placeholderURL + '" alt="">');
			$('#action-remove-photo-btn').hide();

		});

	});

	/**
	 * Hide / show controls
	 */
	$('body.page-template-page-tpl-edit-profile').on( 'before-modal-open', function() {

		const $delButton = $('#action-remove-photo-btn'),
		$changePhotoButton = $('#action-change-photo-btn');

		if( $('#modal-user-upload-photo .profile-avatar img').hasClass('default-avatar') ) {
			$delButton.hide();
			$changePhotoButton.html('Upload Photo');
		} else {
			$delButton.show();
			$changePhotoButton.html('Change Photo');
		}

	});

};

export default ( ( $ ) => $( handler ) )( jQuery );
